module.exports = __webpack_public_path__ + "public/images/captcha-triangle-selected.012a378029c121223c0602f9bf090418.svg";